import { defaultHttpClient } from '../../httpClient';

export interface AppVersionConfig {
  forced_update_message: string;
  forced_version: string;
  recommended_update_message: string;
  recommended_version: string;
  fallback_button_title: string;
  fallback_url: string;
}

export interface Category {
  sno: number;
  name: string;
  representative_image: string | null;
  representative_image_url: string | null;
  representative_icon: string | null;
  sub_categories: SubCategory[];
  display_range: number;
  theme: number;
}

export interface SubCategory {
  sno: number;
  name: string;
  display_range: number;
  theme: number;
}

export interface Level {
  name: string;
  level: number;
  level_color: string | null;
  level_image_url: string | null;
  benefit_image_url: string | null;
  required_purchase_amount: number;
  emoney_percent: number;
  coupon_benefit: number;
  benefit_comment: string | null;
  following_group_required_purchase_amount: number;
}

export interface MarketClientDisplayType {
  sno: number;
  name: string;
}

export interface MarketType {
  sno: number;
  name: string;
}

export interface SearchPlaceholder {
  text: string;
  deeplink: string | null;
}

export interface ShakDelivery {
  operation_end_time: string;
  holidays: string[];
  appeal_text: string;
  guide_image: string;
  integrate_guide_image: string;
  search_placeholder: SearchPlaceholder;
}

export interface TodayDelivery {
  guide_image: string;
  integrate_guide_image: string;
  department_deeplink: string;
}

export interface ThirdPLDelivery {
  guide_image: string;
}

export interface PreOrderSalesMethod {
  guide_image: string;
}

export interface QuickDelivery {
  guide_image: string;
  deeplink: string;
}

export interface NativeClientFeatures {
  date_updated: string;
  encrypted_features: string;
}

export interface ConfigResponse {
  app_version: {
    iOS: AppVersionConfig;
    Android: AppVersionConfig;
  };
  categories: Category[];
  levels: Level[];
  available_emoney_for_order_description: string;
  company_info_text: string;
  legal_text: string;
  market_client_display_type: MarketClientDisplayType[];
  latest_theme_collection_opened_at: string;
  market_types: MarketType[];
  shak_delivery: ShakDelivery;
  delivery_holidays: string[];
  today_delivery: TodayDelivery;
  /**
   * 프리오더(사전예약) 관련 config, 안내 이미지 URL등을 받아서 사용
   */
  pre_order_sales_method: PreOrderSalesMethod;
  /**
   * 도착보장(3PL) 관련 config, 안내 이미지 URL등을 받아서 사용
   */
  third_pl_delivery: ThirdPLDelivery;
  quick_delivery: QuickDelivery;
  log_limited_seconds: number;
  log_limited_capacity: number;
  search_placeholder: SearchPlaceholder;
  native_client_features: NativeClientFeatures;
  onboarding_deeplink: string;
  benefits_deeplink: string;
  ad_utm_source_list: string[];
}

export const getConfigs = () => {
  return defaultHttpClient
    .request<ConfigResponse>({
      method: 'GET',
      url: '/api/v2/configs/',
    })
    .then(result => result.data);
};
